import { API_BASE_URL } from "../config";
import { createAuthenticatedClient } from "../authenticatedClient";
import { safeValidate } from "../safeValidate";
import {
  tenantsResponseSchema,
  selectTenantResponseSchema,
  type TenantsResponse,
  type SelectTenantResponse,
} from "../schemas/tenant.schema";

const authenticatedTenantClient = createAuthenticatedClient(
  `${API_BASE_URL}/api/auth/v1`,
);

export const tenantApi = {
  getTenants: async (): Promise<TenantsResponse> => {
    const response =
      await authenticatedTenantClient.get<TenantsResponse>("/user/tenants");
    return safeValidate(tenantsResponseSchema, response, "getTenants");
  },

  selectTenant: async (tenantId: string): Promise<SelectTenantResponse> => {
    const response = await authenticatedTenantClient.post<SelectTenantResponse>(
      "/tenant/select",
      { tenantId },
    );
    return safeValidate(selectTenantResponseSchema, response, "selectTenant");
  },
};
